export default "__VITE_ASSET__abbf597c__"